export default __webpack_public_path__ + "static/media/Suzanne-Rust.d4370e3d.png";